import { Layout } from 'src/ui/app';
import { DashboardView } from 'src/ui/views/Dashboard';
import { useRouter } from 'next/router';
import { useCallback, useEffect, useMemo } from 'react';
import { hostnameIsProd } from 'src/base/utils';
import Home from 'src/ui/views/Dashboard/Tabs/Home/Home';
import useWallet from 'src/hooks/useWallet';
import useProvider from 'src/hooks/useProvider';
import { useStore } from 'src/base/state';


export const DashboardLayout = ( props ) => {
	return (
		<Layout footerVariation="dashboard"
			navigationVariation="dashboard">
			{props.children}
		</Layout>
	);
};
const Dashboard = ( props = {
	selectedTab: {
		text: 'Home',
		content: <Home />,
		requireWalletConnection: false,
	},
} ) => {
	const [connect, address] = useWallet();
	const provider = useProvider();
	const connected = useMemo( () => {
		return !!( address && provider );
	}, [address, provider]);
	const api = useStore( s => s.api );
	const connectWallet = useCallback( () => api.setIsModalOpen( true ), []);


	const DashboardProps = {
		connect, address, connected, connectWallet, provider,
	};

	return <DashboardView {...props}
		{...DashboardProps} />;
};

DashboardLayout.Footer = () => <div>footer</div>;

Dashboard.Layout = DashboardLayout;

export default Dashboard;
